import { Option, MultiSelect } from 'components-antd';
import { Icons } from 'pages/Workshop/Icons';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { Avatar, Checkbox } from 'components';
import { useState } from 'react';

type MultiSelectSectionPropsType = {
  placeholder: string;
  entityList: { value: string | number; label: string; src?: string }[];
  entity: any;
  setEntity: (value: any) => void;
};

export const MultiSelectSection = (props: MultiSelectSectionPropsType) => {
  const { placeholder, entityList, entity, setEntity } = props;
  const [selected, setSelected] = useState<string[]>([]);

  const getPlaceHolder = (fullName) => {
    const nameArray = fullName.split(' ');
    const firstName = nameArray[0];
    const lastName = nameArray[nameArray.length - 1];
    return firstName?.charAt(0)?.toUpperCase() + lastName?.charAt(0)?.toUpperCase();
  };

  const customFilterOption = (inputValue: string, option) => {
    const value = option?.props?.children?.props?.children?.[2]?.props?.children;
    if (!value) return false;
    return value?.toLowerCase()?.indexOf(inputValue?.toLowerCase()) !== -1;
  };

  const handleDDChange = (values) => {
    const newEntityValues: string[] = [];
    for (let i = 0; i < values.length; i++) {
      if (!selected.includes(values[i]) && !entity.includes(values[i]))
        newEntityValues.push(values[i]);
    }
    setSelected(values);
    setEntity((prev) => [...prev, ...values]);
  };

  return (
    <>
      <MultiSelect
        size="large"
        variant={'search'}
        placeholderText={placeholder}
        onHandleChange={handleDDChange}
        propClass={classNames(styles.multiSelect, {
          [styles.placeholderForSelected]: selected.length > 0,
        })}
        optionFilterProp="children"
        filterOption={customFilterOption}
        wrapperClass={styles.multiSelectWrapper}
        values={selected}
        selectIcon={<Icons variant={'search'} />}
        dropdownClassName={styles.multiSelectDD}
        showClearIcon={true}
        showSearchPlaceholder={false}
        getPopupContainer={(node) => node}
      >
        {entityList.length ? <div className={styles.dropdownHeader}>Search Results</div> : null}
        {entityList?.map((item, idx) => (
          <Option key={idx} value={item.value}>
            <span className={styles.optionContainer}>
              <Avatar
                placeholder={getPlaceHolder(item.label)}
                avatarClassName={styles.avatarCustom}
                src={item.src}
              />
              <span>{item.label}</span>
            </span>
          </Option>
        ))}
      </MultiSelect>

      <>
        {selected?.map((item, idx) => (
          <div
            className={classNames(
              styles.selectedItemsWrapper,
              idx === 0 ? styles.selectedItemsWrapperMargin : undefined,
            )}
            key={idx}
          >
            <div className={styles.leftItemContainer}>
              <Checkbox
                checked={entity.includes(item)}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  if (isChecked) setEntity((prev) => [...prev, item]);
                  else setEntity(entity?.filter((i) => i !== item));
                }}
                className={styles.checkbox}
              />
              <span className={styles.itemText}>
                {entityList.find((e) => e.value === item)?.label}
              </span>
            </div>
            <Icons
              variant={Icons.CLOSE}
              className={styles.crossIcon}
              color="#747475"
              onClick={() => {
                setSelected(selected?.filter((i) => i !== item));
                setEntity(entity?.filter((i) => i !== item));
              }}
            />
          </div>
        ))}
      </>
    </>
  );
};
